import React, { useState, useEffect } from 'react';
import './LookbookPage.scss';

interface LookbookSlide {
  id: number;
  title: string;
  subtitle: string;
  look: string;
}

const lookbookData: LookbookSlide[] = [
  { id: 1, title: 'DÉSTRUCTURÉ', subtitle: 'LOOK 01', look: 'SS25' },
  { id: 2, title: 'DÉSTRUCTURÉ', subtitle: 'LOOK 02', look: 'SS25' },
  { id: 3, title: 'DÉSTRUCTURÉ', subtitle: 'LOOK 03', look: 'SS25' },
  { id: 4, title: 'DÉSTRUCTURÉ', subtitle: 'LOOK 04', look: 'SS25' },
  { id: 5, title: 'DÉSTRUCTURÉ', subtitle: 'LOOK 05', look: 'SS25' },
  { id: 6, title: 'DÉSTRUCTURÉ', subtitle: 'LOOK 06', look: 'SS25' },
];

const LookbookPage: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = (index: number) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 600);
  };

  const nextSlide = () => {
    const next = currentSlide === lookbookData.length - 1 ? 0 : currentSlide + 1;
    goToSlide(next);
  };

  const prevSlide = () => {
    const prev = currentSlide === 0 ? lookbookData.length - 1 : currentSlide - 1;
    goToSlide(prev);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentSlide, isTransitioning]);

  return (
    <div className="lookbook-page">
      {/* Main Slider */}
      <div className="lookbook-page__slider">
        {lookbookData.map((slide, index) => (
          <div 
            key={slide.id}
            className={`lookbook-page__slide ${index === currentSlide ? 'lookbook-page__slide--active' : ''}`}
          >
            <div className="lookbook-page__slide-image">
              <div className="lookbook-page__slide-pattern" />
              <div className="lookbook-page__slide-number">
                {String(slide.id).padStart(2, '0')}
              </div>
            </div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <button 
          className="lookbook-page__nav lookbook-page__nav--prev"
          onClick={prevSlide}
          disabled={isTransitioning}
        >
          <span>←</span>
        </button>
        <button 
          className="lookbook-page__nav lookbook-page__nav--next"
          onClick={nextSlide}
          disabled={isTransitioning}
        >
          <span>→</span>
        </button>
      </div>

      {/* Info Bar */}
      <div className="lookbook-page__info">
        <div className="lookbook-page__info-left">
          <span className="lookbook-page__collection">{lookbookData[currentSlide].look}</span>
          <h1 className="lookbook-page__title">{lookbookData[currentSlide].title}</h1>
        </div>
        <div className="lookbook-page__info-center">
          <span className="lookbook-page__look">{lookbookData[currentSlide].subtitle}</span>
        </div>
        <div className="lookbook-page__info-right">
          <span className="lookbook-page__counter">
            {String(currentSlide + 1).padStart(2, '0')} / {String(lookbookData.length).padStart(2, '0')}
          </span>
        </div>
      </div>

      {/* Thumbnails */}
      <div className="lookbook-page__thumbnails">
        {lookbookData.map((slide, index) => (
          <button
            key={slide.id}
            className={`lookbook-page__thumbnail ${index === currentSlide ? 'lookbook-page__thumbnail--active' : ''}`}
            onClick={() => goToSlide(index)}
          >
            <div className="lookbook-page__thumbnail-inner">
              <span>{String(index + 1).padStart(2, '0')}</span>
            </div>
          </button>
        ))}
      </div>

      {/* Side Text */}
      <div className="lookbook-page__side-text">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
          Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </div>

      {/* Progress Bar */}
      <div className="lookbook-page__progress">
        <div 
          className="lookbook-page__progress-bar"
          style={{ width: `${((currentSlide + 1) / lookbookData.length) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default LookbookPage;

